/*
 *@Description: 批量上传
 *@ComponentAuthor: Xu Jian
*/
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('批量导入')"
      :close-on-click-modal="false"
      :visible.sync="visible"
      @close="close"
      width="900px"
      top="0px"
    >
      <div class="overflow">
        <div class="upload-item">
          <div class="upload" >
            <el-upload
              ref="upload1"
              :action="uploadData1"
              :data="{type:1}"
              :headers="header"
              :multiple="false"
              list-type="text"
              :limit="1"
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-change="handleChange1"
              :on-success="onSuccess1"
              :on-error="onError1"
              :auto-upload="false"
              :on-exceed="onExceed"
            >
              <template slot="default">
                <div class="upload-area">
                    <svg class="icon" aria-hidden="true" v-if="!isActive1">
                        <use xlink:href="#iconwendang-moren"></use>
                    </svg>
                    <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#iconwendang-jihuo"></use>
                    </svg>
                  <p class="name">{{text1 || $lang('点击此处选择Excel文档')}}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <p>{{ $lang('标准模板（无寄件人）') }}</p>
          <div class="button">
            <el-button type="info select" @click="clearFile1" v-if="isActive1">{{ $lang('重新选择') }}</el-button>
            <el-button type="primary" @click="upload1" :loading="upLoading1" v-if="text1 && noError1">{{ $lang('立即上传') }}</el-button>
          </div>
        </div>

         <div class="upload-item">
          <div class="upload" >
            <el-upload
              ref="upload2"
              :action="uploadData2"
              :headers="header"
              :data="{type:2}"
              :multiple="false"
              list-type="text"
              :limit="1"
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-change="handleChange2"
              :on-success="onSuccess2"
              :on-error="onError2"
              :auto-upload="false"
              :on-exceed="onExceed"
            >
              <template slot="default">
                <div class="upload-area">
                    <svg class="icon" aria-hidden="true" v-if="!isActive2">
                        <use xlink:href="#iconwendang-moren"></use>
                    </svg>
                    <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#iconwendang-jihuo"></use>
                    </svg>
                  <p class="name">{{text2 || $lang('点击此处选择Excel文档')}}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <p>{{ $lang('标准模板（含寄件人）') }}</p>
          <div class="button">
            <el-button type="info select" @click="clearFile2" v-if="isActive2">{{ $lang('重新选择') }}</el-button>
            <el-button type="primary" @click="upload2" :loading="upLoading2" v-if="text2 && noError2">{{ $lang('立即上传') }}</el-button>
          </div>
        </div>

         <!-- <div class="upload-item">
          <div class="upload" >
            <el-upload
              ref="upload3"
              :action="uploadData3"
              :data="{type:3}"
              :headers="header"
              :multiple="false"
              list-type="text"
              :limit="1"
              accept=".xls,.xlsx"
              :show-file-list="false"
              :on-change="handleChange3"
              :on-success="onSuccess3"
              :on-error="onError3"
              :auto-upload="false"
              :on-exceed="onExceed"
            >
              <template slot="default">
                <div class="upload-area">
                    <svg class="icon" aria-hidden="true" v-if="!isActive3">
                        <use xlink:href="#iconwendang-moren"></use>
                    </svg>
                    <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#iconwendang-jihuo"></use>
                    </svg>
                  <p class="name">{{text3 || '点击此处选择Excel文档'}}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <p>地址解析（无寄件人）</p>
          <div class="button">
            <el-button type="info select" @click="clearFile3" v-if="isActive3">重新选择</el-button>
            <el-button type="primary" @click="upload3" :loading="upLoading3" v-if="text3 && noError3">立即上传</el-button>
          </div>
        </div>

        <div class="upload-item">
          <div class="upload">
            <el-upload
              ref="upload4"
              :action="uploadData4"
              :data="{type:4}"
              :headers="header"
              :multiple="false"
              list-type="text"
              :show-file-list="false"
              :limit="1"
              accept=".xls,.xlsx"
              :on-change="handleChange4"
              :on-success="onSuccess4"
              :on-error="onError4"
              :auto-upload="false"
              :on-exceed="onExceed"
            >
              <template slot="default">
                <div class="upload-area">
                 <svg class="icon" aria-hidden="true" v-if="!isActive4">
                        <use xlink:href="#iconwendang-moren"></use>
                    </svg>
                    <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#iconwendang-jihuo"></use>
                    </svg>
                  <p class="name">{{text4 || '点击此处选择Excel文档'}}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <p>地址解析（含寄件人）</p>
          <div class="button">
            <el-button type="info select" @click="clearFile4" v-if="isActive4">重新选择</el-button>
            <el-button type="primary" @click="upload4" :loading="upLoading4" v-if="text4 && noError4">立即上传</el-button>
          </div>
        </div> -->
      </div>
      <div class="tips">
        <p>{{ $lang('1、请按照模板内容字段内容顺序正确填写，并按照指定模板内容导入；') }}</p>
        <p>{{ $lang('2、单次最多导入1000条数据；') }}</p>
        <p>{{ $lang('3、"地址智能识别"由第三方服务商提供技术支持，请仔细检查解析后的地址是否正确，如解析错误需要自行手动纠正；') }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EXCEL_IMPORT } from '@constants'
import { mapGetters } from 'vuex'
import store from '@store'

export default {
  name: 'BatchUpload',
  props: {
    value: {},
    spotType: {
      type: String,
      default: '',
    },
    orderTemplate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
      text1: '',
      text2: '',
      text3: '',
      text4: '',

      uploadData1: EXCEL_IMPORT,
      uploadData2: EXCEL_IMPORT,
      uploadData3: EXCEL_IMPORT,
      uploadData4: EXCEL_IMPORT,

      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,

      upLoading1: false,
      upLoading2: false,
      upLoading3: false,
      upLoading4: false,

      noError1: true,
      noError2: true,
      noError3: true,
      noError4: true,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
    orderTemplate: {
      handler(val) {
      },
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    header() {
      return {
        'authToken': this.userInfo.token,
        'language': localStorage.getItem('lang') || store.getters.lang,
      }
    },
  },

  methods: {
    // —————————————————————— 第一个文件上传相关方法
    handleChange1(file, fileList) {
      //  排除上传成功和失败，只有刚读取的文件才执行上传
      if (!file || file.status !== 'ready') {
        return
      }
      this.text1 = file.name
      this.isActive1 = true
    },
    onSuccess1(data) {
      if (data.code === 1) {
        this.$emit('success', data, 1)
        this.clearFile1()
      } else {
        this.$message.error(data.msg)
        this.noError1 = false
      }
      console.log(1)
      this.upLoading1 = false
    },
    clearFile1() {
      this.$nextTick(() => {
        this.$refs.upload1.clearFiles()
      })
      this.text1 = ''
      this.isActive1 = false
      this.noError1 = true
    },
    onError1() {
      this.upLoading1 = false
    },
    upload1(item) {
      this.upLoading1 = true
      this.$refs.upload1.submit()
    },

    // ——————————————————————第二个文件上传相关方法
    handleChange2(file, fileList) {
      //  排除上传成功和失败，只有刚读取的文件才执行上传
      if (!file || file.status !== 'ready') {
        return
      }
      this.text2 = file.name
      this.isActive2 = true
    },
    onSuccess2(data) {
      if (data.code === 1) {
        this.$emit('success', data, 2)
        this.clearFile2()
      } else {
        this.$message.error(data.msg)
        this.noError2 = false
      }
      this.upLoading2 = false
    },
    clearFile2() {
      this.$nextTick(() => {
        this.$refs.upload2.clearFiles()
      })
      this.text2 = ''
      this.isActive2 = false
      this.noError2 = true
    },
    onError2() {
      this.upLoading2 = false
    },
    upload2(item) {
      this.upLoading2 = true
      this.$refs.upload2.submit()
    },

    // ——————————————————————第三个文件上传相关方法
    handleChange3(file, fileList) {
      //  排除上传成功和失败，只有刚读取的文件才执行上传
      if (!file || file.status !== 'ready') {
        return
      }
      this.text3 = file.name
      this.isActive3 = true
    },
    onSuccess3(data) {
      if (data.code === 1) {
        this.$emit('success', data, 3)
        this.clearFile3()
      } else {
        this.$message.error(data.msg)
        this.noError3 = false
      }
      this.upLoading3 = false
    },
    clearFile3() {
      this.$nextTick(() => {
        this.$refs.upload3.clearFiles()
      })
      this.text3 = ''
      this.isActive3 = false
      this.noError3 = true
    },
    onError3() {
      this.upLoading3 = false
    },
    upload3(item) {
      this.upLoading3 = true
      this.$refs.upload3.submit()
    },
    // ——————————————————————第四个文件上传相关方法
    handleChange4(file, fileList) {
      //  排除上传成功和失败，只有刚读取的文件才执行上传
      if (!file || file.status !== 'ready') {
        return
      }
      this.text4 = file.name
      this.isActive4 = true
    },
    onSuccess4(data) {
      if (data.code === 1) {
        this.$emit('success', data, 4)
        this.clearFile4()
      } else {
        this.$message.error(data.msg)
        this.noError4 = false
      }
      this.upLoading4 = false
    },
    clearFile4() {
      this.$nextTick(() => {
        this.$refs.upload4.clearFiles()
      })
      this.text4 = ''
      this.isActive4 = false
      this.noError4 = true
    },
    onError4() {
      this.upLoading4 = false
    },
    upload4(item) {
      this.upLoading4 = true
      this.$refs.upload4.submit()
    },

    onExceed(file, fileList) {
      this.$message.error(this.$lang('模板已存在,请重新选择'))
    },
    close() {
      this.visible = false
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
      this.clearFile1()
      this.clearFile2()
      this.clearFile3()
      this.clearFile4()
    },
  },
}
</script>

<style scoped lang="scss" scoped>
.overflow {
  text-align: center;
  border-bottom: 1px dashed rgba(238, 238, 238, 1);
  display: flex;
  justify-content: space-around;
}
.overflow  p{
  font-size: 12px;
  color:#999;
}
.upload-area {
  margin-top: 45px;
  .file {
    font-size: 72px;
    background-image: linear-gradient(to bottom, #e0bd7b, #cfa561);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .name {
    font-size: 14px;
  }
  .icon{
      font-size: 48px
  }
}
.upload {
  display: inline-block;
  text-align: center;
  width: 180px;
  height: 170px;
  background: #f7f7f9;
  border-radius: 4px;
  border: 1px solid transparent;
  margin-top: 25px;
}
.tips {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}
.button {
  height: 60px;
  box-sizing: border-box;
  padding: 10px 15px;
}
button.select.is-disabled {
  color: #999;
  border-color: #ebeef5;
  background-color: #ebeef5;
}
</style>
